const fields = ['kind', 'name', 'timezone', 'frequency', 'local_time', 'weekdays', 'month_day',
  'short_month_policy', 'once_local', 'enabled', 'selection_mode', 'material_ids', 'target_scope', 'targets']
const weekdays = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']

export function scheduleDraft(kind, source = {}) {
  return { kind, name: '', timezone: 'Asia/Shanghai', frequency: 'daily', local_time: '09:00',
    weekdays: [], month_day: 1, short_month_policy: 'last_day', once_local: '', enabled: true,
    selection_mode: 'automatic_two', material_ids: [], target_scope: 'all_active_bindings', targets: [],
    ...Object.fromEntries(fields.filter(key => source[key] !== undefined).map(key => [key, JSON.parse(JSON.stringify(source[key]))])),
    _existing: Boolean(source.id || source._existing) }
}

function wallNow(now, timezone) {
  const parts = new Intl.DateTimeFormat('en-CA', { timeZone: timezone, hourCycle: 'h23',
    year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(now)
  const value = Object.fromEntries(parts.map(part => [part.type, part.value]))
  return `${value.year}-${value.month}-${value.day}T${value.hour}:${value.minute}`
}

export function scheduleErrors(draft, now = new Date()) {
  const errors = {}
  try { wallNow(now, draft.timezone) } catch { errors.timezone = '请选择有效时区。' }
  if (draft.kind === 'periodic') {
    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(draft.local_time)) errors.local_time = '请填写小时和分钟。'
    if (draft.frequency === 'weekly' && !draft.weekdays.length) errors.weekdays = '每周请至少选择一天。'
    if (draft.frequency === 'monthly' && (!Number.isInteger(Number(draft.month_day)) || draft.month_day < 1 || draft.month_day > 31)) {
      errors.month_day = '每月日期应为 1 至 31 日。'
    }
  } else if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(draft.once_local || '')) {
    errors.once_local = '请填写完整的日期、小时和分钟。'
  } else if (!errors.timezone && (draft.enabled || !draft._existing) && draft.once_local <= wallNow(now, draft.timezone)) {
    errors.once_local = '预设时间必须晚于当前时间。'
  }
  if (draft.selection_mode === 'explicit_two' && (draft.material_ids.filter(Boolean).length !== 2 || new Set(draft.material_ids).size !== 2)) {
    errors.material_ids = '请预选两张不同的图片。'
  }
  if (draft.target_scope === 'exact_targets' && !draft.targets.length) errors.targets = '请至少选择一台手机助手。'
  return errors
}

export function schedulePayload(draft) {
  const body = Object.fromEntries(fields.map(key => [key, draft[key]]))
  body.month_day = Number(body.month_day)
  body.weekdays = [...body.weekdays].map(Number).sort((a, b) => a - b)
  if (body.kind === 'periodic') body.selection_mode = 'automatic_two'
  if (body.selection_mode === 'automatic_two') body.material_ids = []
  if (body.target_scope === 'all_active_bindings') body.targets = []
  if (body.kind === 'periodic') body.once_local = null
  return body
}

export function scheduleLabel(rule) {
  if (rule.kind === 'once') return `${(rule.once_local || '').replace('T', ' ')}（${rule.timezone}）`
  const frequency = rule.frequency === 'weekly' ? `每${rule.weekdays.map(day => weekdays[day]).join('、')}`
    : rule.frequency === 'monthly' ? `每月 ${rule.month_day} 日${rule.month_day > 28 ? (rule.short_month_policy === 'skip' ? '（短月跳过）' : '（短月最后一天）') : ''}` : '每天'
  return `${frequency} ${rule.local_time}（${rule.timezone}）`
}

export function phaseLabel(phase) {
  return ({ queued: '等待准备', content_preparing: '正在准备内容', waiting_dependencies: '等待必要资料',
    retry_wait: '保留进度，等待重试', scheduled: '内容已准备，等待下发时间', delayed_preparation: '准备延迟，自动继续',
    partially_released: '部分手机内容已可领取', released: '内容已可领取', stopped: '本批已停止' })[phase] || '正在读取状态'
}
